
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useUserStore } from '@/store/userStore';
import { Checkbox } from '@/components/ui/checkbox';

interface AdditionalInformationCardProps {
  formData: {
    emergency_contact: string;
    notes: string;
    bypass_cooldown?: boolean;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSwitchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function AdditionalInformationCard({ formData, handleChange, handleSwitchChange }: AdditionalInformationCardProps) {
  const { t } = useTranslation(["clients", "common"]);
  const { role } = useUserStore();
  const isAdmin = role === "admin";
  
  const handleBypassCooldownChange = (checked: boolean | string) => {
    if (handleSwitchChange) {
      handleSwitchChange({
        target: {
          name: 'bypass_cooldown',
          checked: checked === true
        }
      } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('additionalInformation', { ns: 'clients', defaultValue: 'Additional Information' })}</CardTitle>
        <CardDescription>{t('updateAdditionalInformation', { ns: 'clients', defaultValue: 'Update additional information' })}</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4">
        <div>
          <Label htmlFor="emergency_contact">{t('emergencyContact', { ns: 'clients', defaultValue: 'Emergency Contact' })}</Label>
          <Input
            id="emergency_contact"
            name="emergency_contact"
            value={formData.emergency_contact}
            onChange={handleChange}
            placeholder={t('emergencyContactPlaceholder', { ns: 'clients', defaultValue: 'Name and phone number' })}
          />
        </div>
        <div>
          <Label htmlFor="notes">{t('notes', { ns: 'clients', defaultValue: 'Notes' })}</Label>
          <Textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          />
        </div>
        {isAdmin && (
          <div className="flex items-center space-x-2">
            <Checkbox
              id="bypass_cooldown"
              checked={formData.bypass_cooldown || false}
              onCheckedChange={handleBypassCooldownChange}
            />
            <Label htmlFor="bypass_cooldown" className="text-sm font-medium">
              {t('additionalInformation.bypassCooldownLabel', { ns: 'adminui3' })}
            </Label>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
